import React, { memo } from 'react';
import { Icon, Stack, Typography, Divider } from 'investira.react.components';
import { formats } from 'investira.sdk';
const AvaliacaoOutputHeader = memo(props => {
  const { created, gestor = {}, usuarioName, usuarioUsername } = props;
  const xAvaliador = usuarioName || usuarioUsername || 'Não informado';
  const xGestor = gestor.pessoa_fantasia || gestor.pessoa || 'Não informado';
  return (
    <Stack
      direction="row"
      gap={1.5}
      alignItems="center"
      sx={{
        flex: 1,
        minWidth: 0
      }}>
      <Icon iconName="calendar" color="textSecondary" size={16} />
      <Typography variant="caption" color="textSecondary">
        {created && formats.formatDateCustom(created, 'DD/MM/YYYY')}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography variant="caption" color="textSecondary">
        {xGestor}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography variant="caption" color="textSecondary">
        Avaliador: {xAvaliador}
      </Typography>
    </Stack>
  );
});
export default AvaliacaoOutputHeader;
